import { render, staticRenderFns } from "./newGroupMapping.vue?vue&type=template&id=15056d30&"
import script from "./newGroupMapping.vue?vue&type=script&lang=js&"
export * from "./newGroupMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15056d30')) {
      api.createRecord('15056d30', component.options)
    } else {
      api.reload('15056d30', component.options)
    }
    module.hot.accept("./newGroupMapping.vue?vue&type=template&id=15056d30&", function () {
      api.rerender('15056d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftList/components/newGroupMapping.vue"
export default component.exports